"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _I18n = _interopRequireDefault(require("I18n"));

var _q = _interopRequireDefault(require("q"));

var _DateRangeUtils = require("../utils/DateRangeUtils");

var ANALYTICS_BASE = '/activities/v2/forms';
var CONTACTS_BASE = '/contacts/search/v1/report/contacts/multi';

function generateFilterList(formGuids, start, end) {
  return formGuids.map(function (g) {
    var filters = [{
      property: 'formSubmissions.formId',
      operator: 'EQ',
      value: g
    }];

    if (start) {
      filters.push({
        property: 'createdate',
        operator: 'GTE',
        value: start
      });
    }

    if (end) {
      filters.push({
        property: 'createdate',
        operator: 'LTE',
        value: end
      });
    }

    return {
      filterGroups: [{
        filters: filters
      }]
    };
  });
}

var _default = {
  fetchDynosAnalytics: function fetchDynosAnalytics() {
    var formGuids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var start = arguments.length > 1 ? arguments[1] : undefined;
    var end = arguments.length > 2 ? arguments[2] : undefined;
    var query = {
      d1: formGuids
    };
    var dateRangeId = 'ALL';

    if (start && end) {
      dateRangeId = (0, _DateRangeUtils.rangeTag)(start, end);
      query.start = (0, _DateRangeUtils.analyticsDate)(start);
      query.end = (0, _DateRangeUtils.analyticsDate)(end);
      start = (0, _DateRangeUtils.contactsDate)(start);
      end = (0, _DateRangeUtils.contactsDate)(end);
    } // Simultaneously get Contacts and Forms analytics
    // and return them as a single Promise object


    return _q.default.Promise.all([_apiClient.default.get(ANALYTICS_BASE + "/total", {
      query: query,
      headers: {}
    }), _apiClient.default.post("" + CONTACTS_BASE, {
      data: generateFilterList(formGuids, start, end)
    }), formGuids, dateRangeId]);
  },
  fetchDynoDetailsAnalytics: function fetchDynoDetailsAnalytics(formGuid) {
    return _apiClient.default.get(ANALYTICS_BASE + "/d", {
      query: {
        end: _I18n.default.moment().portalTz().format(_DateRangeUtils.ANALYTICS_DATE_FORMAT),
        d1: formGuid
      }
    });
  }
};
exports.default = _default;
module.exports = exports.default;